import React from "react";
import { useNavigate } from 'react-router-dom';
import styles from "./MentionsLegalesPage.module.scss"; // Asegúrese de tener un archivo SCSS correspondiente

import Footer from '../../components/Footer/Footer';

const MentionsLegalesPage_Es = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className={styles.container}>
        <h1>Aviso legal</h1>

        <hr />
        <section>
          <h2>1. Publicador del sitio web / aplicación</h2>
          <p><strong>Nombre de la empresa o editor:</strong> Hatanna Éditions (Micro), representada por la Sra. Célia Barbier.</p>
          <p><strong>Sede:</strong> 173 Bd National 84400 APT</p>
          <p><strong>Número de registro (SIREN):</strong> 832486237</p>
          <p><strong>Correo electrónico de contacto:</strong> <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a></p>
        </section>

        <section>
          <h2>2. Alojamiento</h2>
          <p><strong>Nombre del proveedor de alojamiento:</strong> OVH RCS Roubaix – Tourcoing 424 761 419 00045 Código APE 6202A</p>
          <p><strong>Dirección:</strong> 2 rue Kellermann - 59100 Roubaix - Francia</p>
        </section>

        <section>
          <h2>3. Propiedad intelectual</h2>
          <p>
            Todo el contenido presente en la aplicación (textos, imágenes, videos, códigos fuente, diseño, logotipo...)
            está protegido por la ley de propiedad intelectual. Cualquier reproducción, distribución o modificación
            sin autorización previa está prohibida y puede dar lugar a acciones legales.
          </p>
        </section>

        <section>
          <h2>4. Datos personales y privacidad</h2>
          <p>
            Los datos recopilados a través de la aplicación se procesan de acuerdo con nuestra
            <a className={styles.link} onClick={() => navigate("/privacy")} rel="noopener noreferrer"> política de privacidad</a>.
            De acuerdo con el <strong>Reglamento General de Protección de Datos (RGPD)</strong>, usted tiene derecho
            a acceder, corregir y eliminar sus datos personales poniéndose en contacto con nosotros en: [Correo electrónico de contacto].
          </p>
        </section>

        <section>
          <h2>5. Responsabilidad</h2>
          <p>
            El editor de la aplicación no se hace responsable de:
          </p>
          <ul>
            <li>Interrupciones temporales del servicio debido a operaciones de mantenimiento.</li>
            <li>Errores u omisiones en el contenido mostrado.</li>
            <li>Daños relacionados con el uso de la aplicación por parte del usuario.</li>
          </ul>
        </section>

        <section>
          <h2>6. Enlaces hipertexto</h2>
          <p>
            La aplicación puede contener enlaces a sitios web de terceros. El editor declina toda responsabilidad
            sobre el contenido de estos sitios y las posibles consecuencias de su uso.
          </p>
        </section>

        <section>
          <h2>7. Ley aplicable</h2>
          <p>
            Este aviso legal se rige por la legislación francesa (o cualquier otra jurisdicción aplicable según su país).
            En caso de litigio, los tribunales competentes serán los del domicilio social del editor.
          </p>
        </section>

        <section>
          <h2>8. Desarrollo</h2>
          <p>
            Esta aplicación ha sido desarrollada por <strong>Scriptales SAS</strong>
            (<a className={styles.link} href="https://scriptales.fr" target="_blank" rel="noopener noreferrer">https://scriptales.fr</a>).
          </p>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default MentionsLegalesPage_Es;
